module.exports = __webpack_public_path__ + "components/page-header/static/icon-user-7d63d10c1d1b1f6e8753f842cb657de3.svg";